/** Desenvolvido by Urnau */
console.info("'uutils-email-validator' carregado com sucesso");

    window.uutils = window.uutils || {};

    const fn_load_validacao_de_emails = () => {
        // Início - Utilize suas credenciais cadastradas na origem registradas no Debounce.io.
        const debounce_api_key = 'public_SzFrUHhub0FadlVoVlZsK0hYUFYxQT09';
        // Fim - Utilize suas credenciais cadastradas na origem registradas no Debounce.io.

        const controle = {
            debounce_active: true
        }

        const msg_error_validation_default = "Será que este e-mail está correto? Por favor verifique-o.";

        // MEDIÇÃO (Casa da Toalha, 29/10/2026, só mede, não muda a regra):
        // cada erro leva um "motivo" curto, para contar no GA4 e no Clarity por que o e-mail foi recusado.
        // Nunca envia o e-mail para as ferramentas.
        const fn_erro = (mensagem, motivo) => {
            const erro = new Error(mensagem);
            erro.motivo = motivo;
            return erro;
        };
        // Relógio que não volta para trás (performance.now); sem ele, usa Date.now.
        const fn_agora = () => (window.performance && typeof window.performance.now === "function") ? window.performance.now() : Date.now();

        const list_emails_to_ignore = [
            "10minutemail.com",
            "24hourmail.com",
            "airmail.cc",
            "anonymous.com",
            "boun.cr",
            "brfree.com.br",
            "byom.de",
            "correo.blog",
            "cosmorph.com",
            "discard.email",
            "discardmail.com",
            "dispostable.com",
            "drmail.in",
            "edu.br",
            "email.com.br",
            "email.com",
            "emailfake.com",
            "emailsa.com",
            "emailtemporario.com.br",
            "emailtemporario.com",
            "emaily.pro",
            "example.com",
            "fakeemail.com.br",
            "fakeemail.com",
            "fakeinbox.com",
            "fakemailgenerator.com",
            "getnada.com",
            "gov.br",
            "grr.la",
            "guerrillamail.com",
            "hottempmail.com",
            "inddweg.com",
            "letterhaven.net",
            "mail-temp.com",
            "mail1a.de",
            "mailcatch.com",
            "maildrop.cc",
            "mailfacil.com",
            "mailforspam.com",
            "mailinator.com",
            "mailmetrash.com",
            "mailnesia.com",
            "mailsac.com",
            "makroyal.com",
            "meltmail.com",
            "mintemail.com",
            "moakt.com",
            "mytemp.email",
            "noemail.com",
            "privaterelay.appleid.com",
            "sharklasers.com",
            "spam4.me",
            "spamavert.com",
            "spambox.us",
            "teleworm.us",
            "temp-mail.org",
            "tempail.com",
            "tempmail.dev",
            "tempomail.com.br",
            "temporarymail.com.br",
            "test.com.br",
            "test.com",
            "teste.com.br",
            "teste.com",
            "testing.com",
            "throwawaymail.com",
            "tmail.ws",
            "tmpmail.com",
            "tmpmail.net",
            "trash-mail.com",
            "trashmail.com.br",
            "ufac.br",
            "ufal.br",
            "ufam.edu.br",
            "ufba.br",
            "ufc.br",
            "ufcg.edu.br",
            "ufersa.edu.br",
            "ufg.br",
            "ufma.br",
            "ufmg.br",
            "ufms.br",
            "ufmt.br",
            "ufpa.br",
            "ufpb.br",
            "ufpe.br",
            "ufpel.edu.br",
            "ufpi.br",
            "ufpr.br",
            "ufrgs.br",
            "ufrj.br",
            "ufrn.br",
            "ufrpe.br",
            "ufrr.br",
            "ufs.br",
            "ufsc.br",
            "ufsm.br",
            "uft.edu.br",
            "unb.br",
            "unesp.br",
            "unicamp.br",
            "unifap.br",
            "unifesp.br",
            "unilab.edu.br",
            "unipampa.edu.br",
            "unir.br",
            "univasf.edu.br",
            "uorak.com",
            "usp.br",
            "yomail.info",
            "yopmail.com",
            "zohomail.com.br"
        ];

        const list_start_emails_to_ignore = [
            '1234',
            '12345',
            '123456',
            'abc',
            'atendimento',
            'contact',
            'contato',
            'exemple',
            'exemplo',
            'faleconosco',
            'help',
            'info',
            'loja',
            'noreply',
            'sac',
            'seguro',
            'seguradora',
            'suporte',
            'support',
            'test',
            'teste',
            'web',
            'webmaster'
        ];

        const list_prefix_domains_to_ignore = [
            "gov.br",
            "edu.br"
        ];

        const list_prefix_domains_start_with_to_ignore = [
            "poplk.",
            "uai.",
            "ymail."
        ];

        const list_emails_end_with_domains_incorrects = [
            "gmai.com", "gmai.coml", "gmail.c", "gmail.cim", "gmail.co", "gmail.col", "gmail.com968414", "gmail.coma", "gmail.come", "gmail.comf", "gmail.comh", "gmail.comj", "gmail.coml", "gmail.comm", "gmail.comn", "gmail.comp", "gmail.comr", "gmail.coms", "gmail.con", "gmail.coom", "gmail.cpm", "gmail.fom", "gmail.vom", "gmail.xom",
            "hotkail.com", "hotmail.cim", "hotmail.comk", "hotmail.coml", "hotmail.comm", "hotmail.comn", "hotmail.comp", "hotmail.comr", "hotmail.comt", "hotmail.con", "hotmail.vom", "hotmail.xom",
            "terra.com.brv", "terra.combr", "yahoo.com.r"
        ];

        const fn_email_validator = async (email, medida) => {
            if (email.length < 6) {
                // @role Quando usuário preenche um e-mail com menos de 6 caracteres.
                // throw new Error("Você deve preencher corretamente o campo e-mail.");
                throw fn_erro(msg_error_validation_default || "Você deve preencher corretamente o campo e-mail.", "curto");
            }

            // Validar o formato do e-mail antes de prosseguir
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailPattern.test(email)) {
                // @role Quando usuário preenche um e-mail totalmente inválido (ex: meu_qualquer.coisa, nadaadeclarar, etc)
                throw fn_erro(msg_error_validation_default || "Formato de e-mail inválido. Por favor, insira um e-mail válido.", "formato");
            }

            if (list_emails_end_with_domains_incorrects.some(sufixo => email.toLowerCase().endsWith(`@${sufixo}`))) {
                // @role Quando o domínio está possívelmente escrito errado.
                throw fn_erro(msg_error_validation_default || "Domínio de e-mail possivelmente incorreto. Verifique o e-mail informado e tente novamente.", "dominio_digitado_errado");
            }

            if (list_emails_to_ignore.some(sufixo => email.toLowerCase().endsWith(`@${sufixo}`))) {
                // @role Quando o domínio do e-mail está na nossa lista negra (ex: @teste.com, @anonymous.com )
                throw fn_erro(msg_error_validation_default || "Domínio de e-mail não permitido. Utilize um novo e-mail válido, sugerimos que utilize um e-mail pessoal.", "lista_dominio");
            }

            if (list_start_emails_to_ignore.some(prefixo => email.toLowerCase().startsWith(`${prefixo}@`))) {
                // @role Quando termo antes do @ está na nossa lista negra (ex: teste, sac )
                throw fn_erro(msg_error_validation_default || "E-mail não permitido. Utilize um novo e-mail válido, sugerimos que utilize um e-mail pessoal.", "lista_prefixo");
            }

            const domain = email.split('@')[1];
            if (list_prefix_domains_to_ignore.some(prefixo => domain.toLowerCase().endsWith(`.${prefixo}`))) {
                // @role Quando o término do domínio do e-mail está na nossa lista negra (ex: gov.br, edu.br )
                throw fn_erro(msg_error_validation_default || "Extensão do domínio de e-mail não permitido. Utilize um novo e-mail válido, sugerimos que utilize um e-mail pessoal.", "lista_extensao");
            }

            if (list_prefix_domains_start_with_to_ignore.some(prefixo => domain.toLowerCase().startsWith(prefixo))) {
                // @role Quando o início do domínio do e-mail está na nossa lista negra (ex: poplk, uai, ymail )
                throw fn_erro(msg_error_validation_default || "E-mail contem domínio não permitido. Utilize um novo e-mail válido, sugerimos que utilize um e-mail pessoal.", "lista_inicio_dominio");
            }

            console.debug("Utilizando fluxo central de validação de e-mails", { controle });

            // Faz a validação do e-mail no Debounce.io, em caso de erro, o catch irá tratar o erro e retornar uma exceção.
            if (controle.debounce_active) {
                await fn_validator_debounce(email, medida);
            }

            if (!controle.debounce_active) {
                console.warn("Nenhum serviço de validação de e-mail ativo. O e-mail será aceito sem validações extras.");
            }
        };

        const fn_validator_debounce = async (email, medida) => {
            const inicio_debounce = fn_agora();
            let resposta_recebida = false;
            try {
                const response = await fetch(`https://api.debounce.io/v1/?api=${debounce_api_key}&email=${email}`);
                resposta_recebida = true;
                const data = await response.json();
                if (medida) { medida.tempo_ms = Math.round(fn_agora() - inicio_debounce); }

                if (data.success) {
                    const result = data.debounce;
                    if (result.result === "Safe to Send" && result.free_email == 'true') {
                        return;
                    } else {
                        console.warn("E-mail inválido ou de risco 🚨", result);
                        // Motivo: o resultado da DeBounce (ex.: accept_all, unknown, invalid) ou "nao_gratuito" quando é seguro mas não é e-mail gratuito.
                        // Lista fechada, para o nome do evento nunca ser cortado nem misturar motivos.
                        const mapa_debounce = { "Invalid": "invalid", "Risky": "risky", "Unknown": "unknown", "Accept All": "accept_all", "Accept-All": "accept_all" };
                        const motivo_debounce = (result.result === "Safe to Send")
                            ? "debounce_nao_gratuito"
                            : "debounce_" + (mapa_debounce[result.result] || "outro");
                        throw fn_erro(msg_error_validation_default || "O e-mail digitado pode ser inválido. Tente outro.", motivo_debounce);
                    }
                } else {
                    console.error("Erro na validação do e-mail:", data);
                    throw fn_erro(msg_error_validation_default || "Erro na validação do e-mail.", "debounce_sem_sucesso");
                }
            } catch (error) {
                console.error("Erro ao conectar à API da Debounce.io:", error);
                if (medida && medida.tempo_ms === null) {
                    medida.tempo_ms = Math.round(fn_agora() - inicio_debounce);
                }
                throw fn_erro(error.message || msg_error_validation_default || "Erro ao conectar à API da Debounce.io.", error.motivo || (resposta_recebida ? "debounce_resposta_ruim" : "debounce_falha_conexao"));
            }
        };

        // MEDIÇÃO: conta cada tentativa da sessão e manda só número, resultado, motivo e tempo.
        let tentativa_em_memoria = 0;
        const fn_numero_tentativa = () => {
            tentativa_em_memoria += 1;
            try {
                const chave = "cdt_validador_tentativa";
                const numero = Math.max((parseInt(sessionStorage.getItem(chave), 10) || 0) + 1, tentativa_em_memoria);
                sessionStorage.setItem(chave, String(numero));
                tentativa_em_memoria = numero;
                return numero;
            } catch (e) {
                // Sem sessionStorage: conta só nesta página, para não virar sempre zero.
                return tentativa_em_memoria;
            }
        };

        const fn_faixa_tempo = (ms) => {
            if (ms === null) return "sem_debounce";
            if (ms < 1000) return "ate_1s";
            if (ms < 3000) return "1_a_3s";
            if (ms < 6000) return "3_a_6s";
            return "mais_de_6s";
        };

        // GA4: se o gtag ainda não chegou, guarda e tenta de novo a cada 2 s (até ~60 s) e de novo no fim do carregamento.
        const pendentes_ga4 = [];
        let ga4_agendado = false;
        // Aceite guardado (todo aceite, até o gtag receber sem erro): o rodapé troca de página 1,1 s depois do aceite,
        // e a fila em memória morreria junto. Cada aceite fica numa lista no sessionStorage (com um id) e é
        // reenviado na página seguinte; sai da lista só depois que o gtag recebe.
        const chave_ok_pendente = "cdt_validador_ok_pendente";
        const fn_ler_salvos = () => {
            const lista = JSON.parse(sessionStorage.getItem(chave_ok_pendente) || "[]");
            return Array.isArray(lista) ? lista.filter(x => x && x.id && x.nome === "validador_ok" && x.dados) : [];
        };
        const fn_gravar_salvos = (lista) => {
            if (lista.length) {
                sessionStorage.setItem(chave_ok_pendente, JSON.stringify(lista.slice(-20)));
            } else {
                sessionStorage.removeItem(chave_ok_pendente);
            }
        };
        const fn_tirar_ok_salvo = (item) => {
            if (!item.salvo) return;
            try { fn_gravar_salvos(fn_ler_salvos().filter(x => x.id !== item.salvo)); } catch (e) { /* medição nunca atrapalha */ }
        };
        const fn_esvaziar_ga4 = (voltas) => {
            ga4_agendado = false;
            if (typeof window.gtag === "function") {
                while (pendentes_ga4.length) {
                    const item = pendentes_ga4.shift();
                    try {
                        window.gtag("event", item.nome, item.dados);
                        fn_tirar_ok_salvo(item); // só sai da lista se o gtag aceitou sem erro
                    } catch (e) { /* medição nunca atrapalha */ }
                }
                return;
            }
            if (voltas < 30 && pendentes_ga4.length) {
                ga4_agendado = true;
                setTimeout(() => fn_esvaziar_ga4(voltas + 1), 2000);
                return;
            }
            // Passou de ~60 s sem gtag: deixa na fila oficial do GA4 (dataLayer, mesmo formato do gtag),
            // que o gtag lê quando carregar. Assim nada fica preso aqui.
            // O aceite guardado NÃO vai para o dataLayer: continua só no sessionStorage e é tentado de novo
            // na próxima página (se fosse para os dois, podia contar duas vezes).
            while (pendentes_ga4.length) {
                const item = pendentes_ga4.shift();
                if (item.salvo) continue;
                try {
                    window.dataLayer = window.dataLayer || [];
                    // Formato "arguments", igual ao gtag(); objeto comum não é lido como evento.
                    window.dataLayer.push((function () { return arguments; })("event", item.nome, item.dados));
                } catch (e) { /* medição nunca atrapalha */ }
            }
        };

        window.addEventListener("load", () => { if (!ga4_agendado) { fn_esvaziar_ga4(0); } });

        // Página seguinte ao aceite: reenvia o aceite que ficou guardado. A chave só sai depois que o gtag
        // recebe o evento; se esta página também trocar antes disso, a próxima tenta de novo.
        try {
            if (sessionStorage.getItem(chave_ok_pendente)) {
                const salvos = fn_ler_salvos();
                fn_gravar_salvos(salvos);
                salvos.forEach(x => pendentes_ga4.push({ nome: x.nome, dados: x.dados, salvo: x.id }));
                if (salvos.length && !ga4_agendado) { fn_esvaziar_ga4(0); }
            }
        } catch (e) {
            // Medição nunca pode atrapalhar a página. Registro estragado sai, para não ficar preso.
            try { sessionStorage.removeItem(chave_ok_pendente); } catch (e2) { /* sem sessionStorage */ }
        }

        const fn_registrar_tentativa = (tentativa, resultado, motivo, tempo_ms) => {
            const nome_evento = resultado === "aceito" ? "validador_ok" : ("validador_recusa_" + motivo).slice(0, 40);
            const faixa = fn_faixa_tempo(tempo_ms);
            try {
                const item = {
                    nome: nome_evento,
                    dados: {
                        validador_tentativa: tentativa,
                        validador_resultado: resultado,
                        validador_motivo: motivo,
                        // No GA4 o tempo é número: -1 quando não houve consulta à DeBounce (no Clarity vira "sem_debounce").
                        validador_tempo_ms: tempo_ms === null ? -1 : tempo_ms
                    }
                };
                // Todo aceite é guardado antes de tentar o envio; sai da lista só quando o gtag recebe sem erro.
                if (resultado === "aceito") {
                    try {
                        const id = tentativa + "_" + Date.now();
                        fn_gravar_salvos(fn_ler_salvos().concat([{ id: id, nome: item.nome, dados: item.dados }]));
                        item.salvo = id;
                    } catch (e) { /* sem sessionStorage: fica só a fila em memória */ }
                }
                pendentes_ga4.push(item);
                if (!ga4_agendado) { fn_esvaziar_ga4(0); }
            } catch (e) {
                // Medição nunca pode atrapalhar o cadastro.
            }
            try {
                // Fila do Clarity: o Clarity carrega atrasado (theme.liquid); a fila guarda até ele chegar.
                // Limite conhecido: no rodapé, um aceite feito antes de o Clarity carregar some com a troca de página;
                // a conta de aceites é a do GA4 (validador_ok), que é reenviado na página seguinte.
                window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
                window.clarity("event", nome_evento);
                // Evento com o número da tentativa junto do resultado: liga "qual tentativa foi recusada e por quê".
                const rotulo_tentativa = tentativa >= 99 ? "99_mais" : String(tentativa);
                window.clarity("event", "validador_t" + rotulo_tentativa + "_" + (resultado === "aceito" ? "ok" : motivo));
                window.clarity("event", "validador_tempo_" + faixa);
                // Tempo preso à tentativa: as marcas de tempo abaixo são trocadas pela tentativa seguinte, este evento não.
                window.clarity("event", "validador_t" + rotulo_tentativa + "_tempo_" + faixa);
                // Recusa vai numa marca só dela, para o aceite depois não apagar o motivo da recusa.
                if (resultado !== "aceito") {
                    window.clarity("set", "validador_recusa_motivo", motivo);
                }
                window.clarity("set", "validador_resultado", resultado);
                window.clarity("set", "validador_tentativa", String(tentativa));
                window.clarity("set", "validador_tempo", faixa);
                window.clarity("set", "validador_tempo_ms", tempo_ms === null ? "sem_debounce" : String(tempo_ms));
            } catch (e) {
                // Medição nunca pode atrapalhar o cadastro.
            }
        };

        window.uutils.email_validator = async (email) => {
            const tentativa = fn_numero_tentativa();
            const medida = { tempo_ms: null };
            try {
                await fn_email_validator(email, medida);
            } catch (erro) {
                fn_registrar_tentativa(tentativa, "recusado", (erro && erro.motivo) || "desconhecido", medida.tempo_ms);
                throw erro;
            }
            fn_registrar_tentativa(tentativa, "aceito", "ok", medida.tempo_ms);
        };
    };


    fn_load_validacao_de_emails();
